import React from 'react';

const IconicBadge = () => (
    <svg className="map-badge-iconic map-badge" viewBox="0 0 20 20">
        <path
            className="map-badge-stroke-outter"
            d="M10-2A12,12,0,1,0,22,10,12,12,0,0,0,10-2Zm0,22A10,10,0,1,1,20,10,10,10,0,0,1,10,20Z"
        />
        <circle className="map-badge-iconic-bg" cx="10" cy="10" r="10" />
        <path
            className="map-badge-iconic-stroke"
            d="M10,1.25A8.75,8.75,0,1,1,1.25,10,8.76,8.76,0,0,1,10,1.25M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Z"
        />
        <path
            className="map-badge-iconic-shape"
            d="M10.32,3.61,11.6,7.53a.34.34,0,0,0,.32.24H16a.34.34,0,0,1,.2.62L12.91,10.8a.34.34,0,0,0-.12.38l1.27,3.91a.34.34,0,0,1-.53.38L10.2,13.05a.34.34,0,0,0-.4,0L6.47,15.47a.34.34,0,0,1-.53-.38l1.27-3.91a.34.34,0,0,0-.12-.38L3.77,8.38A.34.34,0,0,1,4,7.76H8.08a.34.34,0,0,0,.32-.24L9.68,3.61A.34.34,0,0,1,10.32,3.61Z"
        />
    </svg>
);

export default IconicBadge;
